import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Button } from '@/common/Button.tsx'
import { LoadingButton } from '@/common/loaders/loadingbutton.jsx'

const ExternalWorkforceFooter = ({
  handleClose,
  handleSubmit,
  submitForm,
  person,
  handleEmploymentEnd,
  handleEmploymentOpen,
}) => {
  const { t } = useTranslation()

  const hasStartDate = !!person?.externalContractInfo?.externalStartDate
  const hasEndDate = !!person?.externalContractInfo?.externalEndDate
  const showEndButton = hasStartDate && !hasEndDate
  const showOpenButton = hasStartDate && hasEndDate

  return (
    <Modal.Footer style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Button
        testId="cancel"
        variant="cancel"
        onClick={handleClose}
        disabled={submitForm}
      >
        {t('Cancel', 'Peruuta')}
      </Button>
      <div style={{ display: 'flex', gap: '8px' }}>
        {showEndButton && (
          <Button
            testId="end-contract"
            variant="error"
            onClick={handleEmploymentEnd}
            disabled={submitForm}
          >
            {t('EndContract', 'Päätä sopimus')}
          </Button>
        )}
        {showOpenButton && (
          <Button
            testId="open-contract"
            variant="primary"
            onClick={handleEmploymentOpen}
            disabled={submitForm}
          >
            {t('ReopenContract', 'Aloita sopimus uudelleen')}
          </Button>
        )}
        <Button
          testId="save"
          variant="primary"
          onClick={handleSubmit}
          disabled={submitForm}
        >
          {submitForm && <LoadingButton />}
          {t('Save', 'Tallenna')}
        </Button>
      </div>
    </Modal.Footer>
  )
}

export default ExternalWorkforceFooter
